import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
  Timestamp,
  UserSettings,
} from '@griply/types';
import { buildTodayFilterDocument } from '@griply/utils';

// The side panel always shows habits, so the type filter that
// buildTodayFilterDocument derives from todayHideHabits is stripped.
export const getSidePanelFilterDocument = (
  today: Timestamp,
  settings?: UserSettings,
): FilterDocument => {
  const document = buildTodayFilterDocument(today, settings);

  return {
    ...document,
    [DocumentOrganizationKeys.Filters]: {
      ...document[DocumentOrganizationKeys.Filters],
      [FilterOptionKeys.Type]: null,
    },
  };
};
